import { render } from "./BasicPage.vue?vue&type=template&id=04e98050&scoped=true"
import script from "./BasicPage.vue?vue&type=script&lang=js"
export * from "./BasicPage.vue?vue&type=script&lang=js"

import "./BasicPage.vue?vue&type=style&index=0&id=04e98050&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04e98050"

export default script